import type { CommunityPostStatus, CommunityPostType } from "@/marketing/models/community";

export const COMMUNITY_KEYS = {
  all: ["community"] as const,
  picks: () => [...COMMUNITY_KEYS.all, "picks"] as const,
  guides: () => [...COMMUNITY_KEYS.all, "guides"] as const,
  posts: (type: CommunityPostType, status?: CommunityPostStatus) =>
    [...COMMUNITY_KEYS.all, "posts", type, status ?? "all"] as const,
  comments: (postId: string) =>
    [...COMMUNITY_KEYS.all, "comments", postId] as const,
  trending: () => [...COMMUNITY_KEYS.all, "trending"] as const,
  categories: () => [...COMMUNITY_KEYS.all, "categories"] as const,
};
